var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGcp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.084 8.50136 2.5161-2.0012-.4428-.55035c-2.0247-1.77665-4.8614-2.39487-7.44816-1.62362-2.58672.77125-4.59661 2.85478-5.3037 5.44593-.04112.15059.41531-.13077.61708-.07544l3.47688-.57004s.17-.16546.26839-.27289c1.54661-1.68867 4.16821-1.90918 5.95391-.47247z",
    fill: "#ea4335"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19.5156 9.73306c-.3996-1.46292-1.22-2.77806-2.3606-3.78409l-2.4399 2.4257c1.0303.83694 1.6172 2.09773 1.592 3.42023v.4306c1.1993 0 2.1716.9665 2.1716 2.1588s-.9723 2.1589-2.1716 2.1589l-4.343-.0032-.4331.0459v3.3438l.4331.0701h4.343c2.4902.0193 4.6992-1.5849 5.4381-3.9492.7388-2.3642-.1669-4.9305-2.2296-6.31754z",
    fill: "#4285f4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m7.6151 19.9983h4.343v-3.4582h-4.343c-.30942-.0001-.61522-.0873-.89667-.2151l-.60998.1879-1.75063 1.7284-.1525.5963c.98172.737 2.17962 1.166 3.40978 1.1607z",
    fill: "#34a853"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m7.615 8.76273c-2.41241.01433-4.54939 1.55027-5.31929 3.82327-.76991 2.273-.00278 4.7893 1.90951 6.2515l2.51921-2.5127c-.88018-.3953-1.39192-1.3211-1.25576-2.2717s.8875-1.6976 1.8437-1.833c.95619-.1353 1.8874.3734 2.28506 1.2485l2.51917-2.5045c-1.0718-1.39314-2.73741-2.20762-4.5016-2.20137z",
    fill: "#fbbc05"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGcp);
export default __webpack_public_path__ + "static/media/gcp.413d5cba5f3e2ecbbaba388be98313c1.svg";
export { ForwardRef as ReactComponent };